import { render } from "./CadastrarCompras.vue?vue&type=template&id=5d9efc7c"
import script from "./CadastrarCompras.vue?vue&type=script&lang=js"
export * from "./CadastrarCompras.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__